import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator"; // 微信-演出赛事

import $ from 'zepto';
import Cookie from '../utils/cookie';
import utils from '../utils';
import KNB from '@dp/knb';
var PROTOCAL = location.protocol;
export default {
  appName: 'maoyan_wechat',
  useKNB: false,
  sellChannel: 6,
  theme: 'maoyan',
  hostPrefix: '//m.maoyan.com/myshow/fe',
  hostBetaPrefix: '//myshow.test.maoyan.com/fe',
  loginUrl: PROTOCAL + '//m.maoyan.com/wxlogin?from=mmweb&redirectURL=',
  loginBetaUrl: PROTOCAL + '//m.maoyan.com/wxlogin?from=mmweb&redirectURL=',
  ajaxUrl: '//wx.maoyan.com/maoyansh/myshow/ajax',
  ajaxBetaUrl: '//m.51ping.com/myshow/ajax',
  preInit: function preInit() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 禁用KNB WECHAT
              window._KNB_IGNORE_WECHAT = true; // // 加载微信API

              _context2.next = 3;
              return utils.loadScript('//s0.meituan.net/bs/delivr/0315c86:jsm/lib/weixin/jweixin-1.1.0.js');

            case 3:
              wx._config = wx.config;
              wx.config = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var AppData;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        AppData = window.AppData;

                        if (!(AppData && AppData.$wechat)) {
                          _context.next = 3;
                          break;
                        }

                        return _context.abrupt("return", _this.initWxSDK(AppData.$wechat));

                      case 3:
                        return _context.abrupt("return", new Promise(function (resolve, reject) {
                          $.get(PROTOCAL + '//m.maoyan.com/wechat?channelId=70001', {
                            _v_: 'yes',
                            url: location.href.split('#')[0]
                          }, function (config) {
                            resolve(_this.initWxSDK(config));
                          });
                        }));

                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));
              _context2.next = 7;
              return wx.config();

            case 7:
              wx._chooseWXPay = wx.chooseWXPay;

              wx.chooseWXPay = function (opt) {
                opt.timestamp = opt.timestamp || opt.timeStamp;

                wx._chooseWXPay(opt);
              };

              _this.wxShareInit();

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  initWxSDK: function initWxSDK(config) {
    var jsApiList = ['onMenuShareTimeline', 'onMenuShareAppMessage', 'hideMenuItems', 'getLocation'];

    if (config.signature) {
      config.nonceStr = config.noncestr;
      window.AppData = window.AppData || {};
      window.AppData.$wechat = config;
      config.jsApiList = config.jsApiList || [];
      jsApiList.forEach(function (item) {
        if (config.jsApiList.indexOf(item) === -1) {
          config.jsApiList.push(item);
        }
      });

      wx._config(config);
    } else {
      throw new Error('微信验签接口无效, 请检查请求 /wechat 的响应');
    }
  },
  wxShareInit: function wxShareInit() {
    var noop = function noop() {};

    var wx = function wx() {
      return window.wx || function (ref) {
        return (ref.fail || noop)({
          error: -1,
          msg: 'wx sdk is not loaded'
        });
      };
    };

    KNB.configShare = function () {
      var _channelMap;

      var ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _KNB$share = KNB.share,
          WECHAT_FRIENDS = _KNB$share.WECHAT_FRIENDS,
          WECHAT_TIMELINE = _KNB$share.WECHAT_TIMELINE,
          QQ = _KNB$share.QQ,
          QZONE = _KNB$share.QZONE;
      var channelMap = (_channelMap = {}, _defineProperty(_channelMap, WECHAT_FRIENDS, wx().onMenuShareAppMessage), _defineProperty(_channelMap, WECHAT_TIMELINE, wx().onMenuShareTimeline), _defineProperty(_channelMap, QQ, wx().onMenuShareQQ), _defineProperty(_channelMap, QZONE, wx().onMenuShareQZone), _channelMap);
      var title = ref.title,
          desc = ref.desc,
          image = ref.image,
          url = ref.url,
          channel = ref.channel,
          success = ref.success,
          fail = ref.fail;
      desc = desc || '';
      image = image || '';
      url = image || '';
      channel = channel || Object.keys(channelMap);
      success = success || noop;
      fail = fail || noop;
      channel.map(function (c) {
        return channelMap[c];
      }).filter(Boolean).forEach(function (configure) {
        return configure({
          title: title,
          desc: desc,
          link: url,
          imgUrl: image,
          success: success,
          fail: fail
        });
      });
    };
  },
  getUserInfo: function getUserInfo() {
    var user = Cookie.get('wxw-user');
    var token = '',
        openId = '',
        userId = '';

    try {
      var _decodeURIComponent$s = decodeURIComponent(user).split(',');

      var _decodeURIComponent$s2 = _slicedToArray(_decodeURIComponent$s, 2);

      userId = _decodeURIComponent$s2[0];
      token = _decodeURIComponent$s2[1];
      openId = Cookie.get('wxw-openid') || '';
    } catch (error) {}

    return {
      token: token,
      openId: openId,
      userId: userId,
      userOpenId: openId
    };
  },
  getLocation: function getLocation() {
    var lat = 0,
        lng = 0;
    var location = Cookie.get('wxw-latlng');

    try {
      var _decodeURIComponent$s3 = decodeURIComponent(location).split(',');

      var _decodeURIComponent$s4 = _slicedToArray(_decodeURIComponent$s3, 2);

      lat = _decodeURIComponent$s4[0];
      lng = _decodeURIComponent$s4[1];
    } catch (error) {}

    return {
      lat: lat,
      lng: lng
    };
  },
  getCity: function getCity() {
    var cityId = 1,
        cityName = '';
    var cityInfo = Cookie.get('wxw-ct');

    try {
      var _decodeURIComponent$s5 = decodeURIComponent(cityInfo).split(',');

      var _decodeURIComponent$s6 = _slicedToArray(_decodeURIComponent$s5, 2);

      cityId = _decodeURIComponent$s6[0];
      cityName = _decodeURIComponent$s6[1];
    } catch (error) {}

    return {
      cityId: cityId === 'undefined' ? 1 : cityId || 1,
      cityName: cityName
    };
  }
};